import { useNavigate } from "react-router-dom";

const Experience = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-16 sm:mt-20 md:mt-32 px-4 sm:px-6 md:px-0">
      <h1 className="text-2xl sm:text-3xl md:text-4xl">Work Experience</h1>
      <div className="flex flex-col mt-4">
        <div className="w-full p-4 sm:p-5 m-2 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">Software Engineer Intern</span>
            <span className="text-xs sm:text-sm opacity-80">
              08/2025 - 02/2026
            </span>
          </div>
          <span className="text-sm font-normal text-gray-500">StashAway</span>
          <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
            Developed full-stack features using TypeScript and Go with MongoDB
            and PostgreSQL databases, implementing query optimizations and
            filtering systems.
            <br></br>
            <br></br>
            Executed data backfilling via Rundeck for 500+ user records and
            worked with Kafka event streaming to improve performance by 80% and
            data consistency issues.
          </span>
        </div>
        <div className="w-full p-4 sm:p-5 m-2 mt-5 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">
              Capture The Flag Coordinator
            </span>
            <span className="text-xs sm:text-sm opacity-80">
              05/2023 - 06/2023
            </span>
          </div>
          <span className="text-sm font-normal text-gray-500">
            National University of Malaysia
          </span>
          <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
            Coordinated and led a dynamic Capture the Flag (CTF) workshop,
            educating 30+ participants on cryptography, steganography, and other
            cybersecurity concepts
            <br></br>
            <br></br>
            Developed comprehensive curriculum modules covering diverse topics
            such as cryptographic algorithms, encryption techniques, and data
            hiding methods
            <br></br>
          </span>
        </div>
        <div className="w-full p-4 sm:p-5 m-2 mt-5 flex flex-col items-start bg-gray-50 rounded-3xl cursor-pointer hover:bg-gray-100 text-left">
          <div className="w-full flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
            <span className="text-lg sm:text-xl">Java Mentor</span>
            <span className="text-xs sm:text-sm opacity-80">
              11/2023 ~ Present
            </span>
          </div>
          <span className="text-sm font-normal text-gray-500">
            National University of Malaysia
          </span>
          <span className="text-sm sm:text-base font-normal mt-3 sm:mt-4">
            Guided students through the principles of OOP, ensuring a solid
            grasp of encapsulation, abstraction, inheritance, and polymorphism.
            <br></br>
            <br></br>
            Designed modules and implemented practical exercises with 20+
            mentees
            <br></br>
          </span>
        </div>
        <div className="flex flex-col items-center">
          <div className="relative z-10 text-black flex flex-col items-center rounded-xl w-32 sm:w-36 bg-white r shadow-lg shadow-sky-500 mt-4">
            <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
            <button
              onClick={() => navigate("/experience")}
              class="relative gradient-border px-3 py-2 sm:px-4 sm:py-2 rounded-xl justify-between bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white w-full text-sm sm:text-base font-normal transform hover:scale-105 duration-300"
            >
              See more
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
